module.exports = __webpack_public_path__ + "static/media/211ME130.4e0f01e1.jpeg";